/**
 * Uses the values computed in vue.config.js 
 */

// Uncomment this for a server-side version
// import apiService from '@/services/ApiService'
// let _versionCache = null

export default {
    data() {
        return {
            appTag: __APP_TAG__,
            appVersion: __APP_VERSION__,
            appVersionDate: __APP_VERSION_DATE__,
        }
    }

    // Uncomment this for a server-side version
    // data() {
    //     return {
    //         appTag: '...',
    //         appVersion: '...',
    //         appVersionDate: '...',
    //     }
    // },
    // async created() {
    //     // Module-level cache — avoids a new HTTP request on every component mount.
    //     // Remove if you want a fresh version fetch each time.
    //     if (_versionCache) {
    //         this.appTag = _versionCache.tag
    //         this.appVersion = _versionCache.hash
    //         this.appVersionDate = _versionCache.date
    //         return
    //     }
    //     try {
    //         const v = await apiService.request('/status/version', { method: 'GET' })
    //         _versionCache = v
    //         this.appTag = v.tag
    //         this.appVersion = v.hash
    //         this.appVersionDate = v.date
    //     } catch (e) {}
    // }
}
